import React, { useEffect } from "react";
import { get } from "lodash";
import { Field } from "redux-form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { required, email } from "redux-form-validators";

import { showToast } from "../../../helpers/notify";
import { getUrlParams } from "../../../helpers/navigation";
import { makeProfileData } from "../../../actions/storage";
import { Button, Checkbox, Input } from "../../../components/Field";
import api from "../../../actions/api";
import Link from "../../../components/Link";
import Text from "../../../components/Text";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import AsyncForm from "../../../components/AsyncForm";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Signin(props) {
    const { 
        title = "", 
        description = "", 
        bottom_text = "", 
        bg_image = "" 
    } = props;
    const navigate = useNavigate();
    const userProfile = useSelector((state) => state.storage.data);
    const dispatch = useDispatch();

    useEffect(() => {
        if (get(userProfile, 'id', null) !== null) {
            const urlParams = getUrlParams();
            if(get(urlParams, "redirect")) {
                navigate(get(urlParams, "redirect"));
            }
            else {
                navigate('/home');
            }
        }
    }, [userProfile, navigate])

    const setProfileData = (data) => {
        if (get(data, "success", false) === true) {
            api.get("/account").then((data) => {
                dispatch(makeProfileData(data.data))
            })
        }
        else {
            showToast(data.message);
        }
    }

    return (
        <Section className={style.signin}>
            <div className={style.signinWrapper}>
                <div className={style.signinBg}>
                    <Background src={bg_image} size="2560x1440" cPosition="bottomLeft" />
                </div>
                <div className={style.formWrapper}>
                    <AsyncForm
                        url="/account/login"
                        permission={false}
                        showToastOnSuccess={false}
                        onSave={({ data }) => {
                            setProfileData(data);
                        }}
                        render={({ fetching }) => (
                            <div className={style.form}>
                                <div className={style.formRow}>
                                    <div className={style.formHeader}>
                                        <div className={style.formTitleWrapper}>
                                            <Title className={style.formTitle} tag="h3">{title}</Title>
                                        </div>
                                        <div className={style.formDescription}>
                                            <Text text={description} />
                                        </div>
                                    </div>
                                </div>
                                <div className={style.formRow}>
                                    <Field
                                        name="email"
                                        component={Input}
                                        validate={[required(), email()]}
                                        placeholder="Enter email address"
                                        label="Email"
                                        required={true}
                                    />
                                </div>
                                <div className={style.formRow}>
                                    <Field
                                        name="password"
                                        type="password"
                                        component={Input}
                                        validate={[required()]}
                                        placeholder="Enter Password"
                                        label="Password"
                                        required={true}
                                    />
                                </div>
                                <div className={`${style.formRow} ${style.formRowJustF}`}>
                                    <div className={style.formColumn}>
                                        <Field
                                            className={style.customCheckbox}
                                            name="remember_me"
                                            component={Checkbox}
                                            checkValue={1}
                                            label="Remember Me"
                                        />
                                    </div>
                                    <div className={style.formColumn}>
                                        <Link
                                            className={style.mainMenuItemLink}
                                            to="/forgot-password"
                                        >
                                            Need help? <span className={`${style.dropDown} ${style.right}`}></span>
                                        </Link>
                                    </div>
                                </div>
                                <div className={`${style.formRow} ${style.formSubmit}`}>
                                    <Button
                                        color="buttonPrimary"
                                        size="buttonFullWidth"
                                        submit={true}
                                        fetching={fetching}
                                        label="SIGN IN"
                                    />
                                </div>
                                <div className={`${style.formRow} ${style.formRowCol}`}>
                                    <Editor text={bottom_text} />
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        </Section>
    )
}